<div class="flex flex-column align-items-center justify-content-center mt-5" *ngIf="!validToken">
    <div class="flex bg-red-200 p-1 border-round-xl w-full flex-column text-center">
        <p-tag [value]="('INVALID_PERMISSION' | translate)" severity="danger" styleClass="text-lg"></p-tag>
        <p-tag [value]="('INVALID_PERMISSION_REASON' | translate)" severity="danger" styleClass="text-lg"></p-tag>
    </div>
</div>

<div *ngIf="!validPin && validToken && !resetPin">
    <app-pin-pad (pinConfirmed)="onPinInserted($event)"></app-pin-pad>
</div>

<div class="flex flex-column align-items-center justify-content-center mt-5" *ngIf="validPin && !resetPin">
    <div class="flex bg-green-200 p-1 border-round-xl w-full"
        [class]="!onMobile() ? 'flex-row justify-content-center' : 'flex-column text-center'">
        <p-tag [value]="('PIN_VALIDITY' | translate)" severity="success"
            [styleClass]="!onMobile() ? 'pr-0 text-lg' : 'text-lg'"></p-tag>
        <p-tag *ngIf="permission !== undefined && permission.End !== undefined"
            [value]="permission.End  | localizedDate: 'medium'" severity="success"
            [styleClass]="!onMobile() ? ' text-lg' : 'text-lg'"></p-tag>
    </div>

    <div class="flex flex-column justify-content-center mt-5" *ngIf="permission !== undefined">
        <p-panel *ngFor="let automation of automationList | keyvalue" header="{{automation.key}}" class="w-full"
            styleClass="mb-3">
            <div class="grid m-0 flex align-items-center justify-content-center">
                <!-- <div class="col-12 flex align-items-center justify-content-center" [class]="this.onMobile() ? 'grid mx-1' : 'grid'"> -->
                <div *ngFor="let cmd of automation.value" [class]="this.onMobile() ? 'col-12 pb-0' : columnNumber">
                    <button type="button" pButton pRipple id="buttonQuickEasyDeviceCommand-{{cmd.CommandDescription}}"
                        [disabled]="!validPin" label="{{ cmd.CommandDescription }}"
                        class="p-button-primary text-lg font-normal w-full" (click)="sendCommand(cmd)">
                    </button>
                </div>
                <!-- </div> -->
            </div>
        </p-panel>
    </div>
</div>